/**
 * Data Profile Feature Module
 *
 * Registers the data-profile workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

registerWorkspaceComponent(
  'data-profile',
  lazyWorkspaceTab(() => import('./components/DataProfileTab').then((m) => ({ default: m.DataProfileTab }))),
);

